module.exports = __webpack_public_path__ + "img/players-2.f2455bfb.png";